const urlsNotToRedirect = [
  '/boot-camps/*',
  '/become/*',
  '/resources/*',
  '/certificates/*',
  '/masters/*',
  '/bachelors/*',
  '/doctorate/*',

  '/boot-camps/microbootcamps',
  '/learn/data-science',
  '/learn/cybersecurity',
  '/learn/computer-science',
  '/learn',
  '/learn/algorithms',
  '/learn/statistics',
  '/learn/r-programming',
  '/learn/trading',
  '/learn/investing',
  '/learn/stocks',
  '/learn/blockchain',
  '/learn/cryptocurrency',
  '/learn/biology',
  '/learn/stem',
  '/learn/genetics',
  '/learn/neuroscience',
  '/learn/nutrition',
  '/learn/human-anatomy',
  '/learn/physics',
  '/learn/dynamics',
  '/learn/nature',
  '/learn/planets',
  '/learn/architecture',
  '/learn/mechanics',
  '/learn/language',
  '/learn/spanish',
  '/learn/social-science',
  '/learn/psychology',
  '/learn/education',
  '/learn/politics',
  '/learn/behavioral-psychology',
  '/learn/government',
  '/learn/math',
  '/learn/probability',
  '/learn/algebra',
  '/learn/calculus',
  '/learn/logic',
  '/learn/geometry',
  '/learn/humanities',
  '/learn/music-arts',
  '/learn/art',
  '/learn/philosophy',
  '/learn/geography',
  '/learn/history',

  '/executive-education/sustainability',
  '/executive-education/data-science',
  '/executive-education/management',
  '/executive-education/data-analytics',
  '/executive-education/product-management',
  '/executive-education/economics',
  '/executive-education/strategy',
  '/executive-education/finance',
  '/executive-education/leadership',
  '/executive-education/fintech',
  '/executive-education/real-estate',
  '/executive-education/blockchain',
  '/executive-education/healthcare',
  '/executive-education/artificial-intelligence',
  '/executive-education/marketing',
  '/executive-education/project-management',
  '/executive-education/digital-marketing',
  '/executive-education/operations-management',
  '/executive-education/design',
  '/executive-education/supply-chain',
  '/executive-education/information-technology',
  '/executive-education/cybersecurity',
  '/executive-education/innovation',
  '/executive-education/negotiation',
  '/executive-education/entrepreneurship',
  '/executive-education/law',
  '/executive-education/digital-transformation',
  '/executive-education/human-resources',
  '/executive-education/talent-management',
  '/executive-education/sales',
  '/executive-education/accounting',
  '/executive-education/change-management',
  '/executive-education/risk-management',
  '/executive-education/international-relations',
  '/executive-education/womens-executive-leadership-program',

  '/learn/chatgpt',
  '/learn/machine-learning',
  '/learn/computer-science',
  '/learn/electronics',
  '/learn/automation',
  '/learn/augmented-reality',
  '/learn/iot-internet-of-things',
  '/learn/software-engineering',
  '/learn/data-mining',
  '/learn/robotics',
  '/learn/deep-learning',
  '/learn/computer-engineering',
  '/learn/algorithms',
  '/learn/natural-language-processing',
  '/learn/computer-programming',
  '/learn/computer-vision',
  '/learn/robotic-process-automation',
  '/learn/computer-networking',
  '/learn/mathematical-modeling',
  '/learn/autonomous-robotics',
  '/learn/power-bi',
  '/learn/sql',
  '/learn/analytics',
  '/learn/mysql',
  '/learn/coding',
  '/learn/postgresql',
  '/learn/big-data',
  '/learn/cloud-computing',
  '/learn/syntax',
  '/learn/statistics',
  '/learn/tensorflow',
  '/learn/probability',
  '/learn/regression',
  '/learn/inference',
  '/learn/pytorch',
  '/learn/grafana',
  '/learn/business-intelligence',
  '/learn/data-warehouse',
  '/learn/data-structures',
  '/learn/data-visualization',
  '/learn/bitcoin',
  '/learn/investing',
  '/learn/cryptocurrency',
  '/learn/blockchain',
  '/learn/trading',
  '/learn/fintech',
  '/learn/stocks',
  '/learn/banking',
  '/learn/risk-management',
  '/learn/venture-capital',
  '/learn/taxes',
  '/learn/investment-banking',
  '/learn/financial-management',
  '/learn/cryptography',
  '/learn/circular-economy',
  '/learn/macroeconomics',
  '/learn/financial-accounting',
  '/learn/financial-literacy',
  '/learn/personal-finance',
  '/learn/corporate-finance',
  '/learn/excel',
  '/learn/marketing',
  '/learn/digital-marketing',
  '/learn/entrepreneurship',
  '/learn/success',
  '/learn/ceo',
  '/learn/management',
  '/learn/sales',
  '/learn/accounting',
  '/learn/leadership',
  '/learn/innovation',
  '/learn/procurement',
  '/learn/scrum',
  '/learn/zapier',
  '/learn/ecommerce',
  '/learn/project-management',
  '/learn/agile',
  '/learn/servicenow',
  '/learn/business-plan',
  '/learn/retail',
  '/learn/information-security',
  '/learn/computer-security',
  '/learn/cloud-computing',
  '/learn/encryption',
  '/learn/security-administration',
  '/learn/security-software',
  '/learn/vulnerability-management',
  '/learn/information-technology',
  '/learn/data-encryption',
  '/learn/software-as-a-service',
  '/learn/user-experience-ux',
  '/learn/cybersecurity',
  '/learn/ux-design',
  '/learn/network-security',
  '/learn/security-testing',
  '/learn/data-management',
  '/learn/technical-analysis',
  '/learn/encryption-software',
  '/learn/decoding',
  '/learn/information-technology',
  '/learn/software-development',
  '/learn/numba',
  '/learn/yaml',
  '/learn/machine-learning',
  '/learn/gparted',
  '/learn/finance',
  '/learn/cakephp',
  '/learn/artificial-intelligence',
];

module.exports = {
  urlsNotToRedirect,
};
